import React from "react";
import { DialogActions } from "@mui/material";

interface StyledDialogActionsProps {
    children?: React.ReactNode; // Accepts single or multiple React nodes
}

const StyledDialogActions: React.FC<StyledDialogActionsProps> = ({ children }) => {
    return (
        <DialogActions
            sx={{
                gap: "12px",
                px: "20px",
                pb: "20px",
            }}
        >
            {children}
        </DialogActions>
    );
};

export default StyledDialogActions;
